import type { ReactNode } from "react";
import { cn } from "../../utils/cn";

export interface CheckboxProps {
  label?: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  indeterminate?: boolean;
  description?: string;
  className?: string;
}

export function Checkbox({
  label,
  checked,
  onChange,
  disabled,
  indeterminate,
  description,
  className,
}: CheckboxProps) {
  return (
    <label className={cn("flex cursor-pointer items-start gap-2.5", disabled && "cursor-not-allowed opacity-60", className)}>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 cursor-pointer accent-primary-600"
        ref={(el) => {
          if (el) el.indeterminate = Boolean(indeterminate);
        }}
      />
      <span className="text-sm">
        <span className={cn("text-foreground-800", disabled && "text-foreground-400")}>{label}</span>
        {description ? <span className="block text-xs text-foreground-500">{description}</span> : null}
      </span>
    </label>
  );
}